import React, { createContext, useContext, useState } from 'react'

export type ModalData = {
    id: string | null
    sku: string | null
    bundles: Bundle[]
    bundleHeadline: string | null
}

export type Bundle = {
    sku: string
    quantity: number
}

interface ModalContextType {
    isOpen: (id: string) => boolean
    openModal: (
        id: string,
        sku: string,
        bundles: Bundle[],
        bundleHeadline: string
    ) => void
    closeModal: () => void
    modalData: ModalData
}

const ModalContext = createContext<ModalContextType | undefined>(undefined)

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({
    children
}) => {
    const [modalData, setModalData] = useState<ModalData>({
        id: null,
        sku: null,
        bundles: [],
        bundleHeadline: null
    })

    const openModal = (
        id: string,
        sku: string,
        bundles: Bundle[],
        bundleHeadline: string
    ) => {
        setModalData({ id, sku, bundles, bundleHeadline })
    }

    const closeModal = () => {
        setModalData({ id: null, sku: null, bundles: [], bundleHeadline: null })
    }

    const isOpen = (id: string) => modalData.id === id

    return (
        <ModalContext.Provider
            value={{ isOpen, openModal, closeModal, modalData }}>
            {children}
        </ModalContext.Provider>
    )
}

export const useModal = () => {
    const context = useContext(ModalContext)

    if (!context) {
        throw new Error('useModal must be used within a ModalProvider')
    }

    return context
}
